import { ToggleCooperateApprovalDocument } from "src/generated-gql/graphql";
import { CooperateUser } from "src/generated-gql/graphql";
import { Component, OnInit } from "@angular/core";
import { Observable, switchMap } from "rxjs";
import { take } from "rxjs/operators";
import { FormGroup, UntypedFormGroup, AbstractControl } from "@angular/forms";
import { CustomFieldConfig } from "@vendure/common/lib/generated-types";
import {
  DataService,
  SharedModule,
  CustomDetailComponent,
  ModalService,
  CustomerDetailQueryDocument,
  NotificationService,
  Asset,
  AssetPreviewDialogComponent,
} from "@bb-vendure/admin-ui/core";

@Component({
  selector: "approval-switch",
  templateUrl: "./panel.component.html",
  standalone: true,
  imports: [SharedModule],
})
export class CooperatePanel implements CustomDetailComponent, OnInit {
  constructor(
    private dataService: DataService,
    private noti: NotificationService,
    private modalService: ModalService
  ) {}
  entity$: Observable<any>;
  detailForm: FormGroup;

  extraInfo$: Observable<any>;
  userType: "general" | "cooperate" = "general";
  cooperateUser: CooperateUser;
  private _isOnInitComplete: boolean = false;

  get isApproved() {
    if (!this.cooperateUser) {
      return false;
    }
    return this.cooperateUser.isApproved;
  }
  set isApproved(v: boolean) {
    const updatedCooperateUser = { ...this.cooperateUser, isApproved: v };
    this.cooperateUser = updatedCooperateUser;
    if (this._isOnInitComplete) {
      this.setApprovalStatus(v);
    }
  }

  ngOnInit(): void {
    const cooperateUserControl = this.detailForm.get(
      "customer.customFields.cooperateUser"
    );

    // cooperateUserControl?.valueChanges.pipe(take(1)).subscribe((v) => {

    // });

    console.log(cooperateUserControl);

    if (cooperateUserControl?.value) {
      this.userType = "cooperate";
      this.cooperateUser = cooperateUserControl?.value;
      this._isOnInitComplete = true;
    }
  }

  setApprovalStatus(v: boolean) {
    const id =
      this.detailForm.get("customer")?.value.customFields.cooperateUser.id;
    this.dataService
      .mutate(ToggleCooperateApprovalDocument, {
        input: {
          id,
          isApproved: v,
        },
      })
      .subscribe((v) => {
        this.noti.success("Approval status updated");
      });
  }

  previewAttachment(asset: { id: string; preview: string }): string {
    return `/assets/${asset.preview}`;
  }

  previewAsset(asset: Asset) {
    this.modalService
      .fromComponent(AssetPreviewDialogComponent, {
        size: "xl",
        closable: true,
        locals: { asset },
      })
      .subscribe();
  }
}
